import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RootLayout } from '@/components/layout/RootLayout';
import { NotFoundPage } from '@/app/NotFoundPage';
import { RequireSession } from '@/app/RequireSession';

/**
 * Route table for the app.
 *
 * Every page is `lazy()`-loaded so a route ships its own chunk — adding a
 * feature must not grow the initial bundle. Register new routes here; features
 * export their page from their own `index.ts` barrel.
 */
const WelcomePage = lazy(() =>
    import('@/features/welcome').then((m) => ({ default: m.WelcomePage }))
);
const SignInPage = lazy(() =>
    import('@/features/auth').then((m) => ({ default: m.SignInPage }))
);
const ConsentPage = lazy(() =>
    import('@/features/consent').then((m) => ({ default: m.ConsentPage }))
);
const RequireConsentRequest = lazy(() =>
    import('@/features/consent').then((m) => ({
        default: m.RequireConsentRequest,
    }))
);

export const routes: RouteObject[] = [
    {
        path: '/',
        element: <RootLayout />,
        children: [
            { index: true, element: <WelcomePage /> },
            { path: 'login', element: <SignInPage /> },
            {
                path: 'authorize',
                // 1. Is there a request id at all? Must run before the
                // session check below, or AC8 breaks — see RequireConsentRequest.
                element: <RequireConsentRequest />,
                children: [
                    {
                        // 2. Pathless guard — is there a session?
                        element: <RequireSession />,
                        children: [{ index: true, element: <ConsentPage /> }],
                    },
                ],
            },
            { path: '*', element: <NotFoundPage /> },
        ],
    },
];
